<template>
    <van-popup
            v-model="show"
            position="center"
            :overlay="true"
            class="red-popup"
            :style="{ width: '280px' }"
            :close-on-click-overlay="false"
    >
        <div class="red-packet">

            <!-- 未拆 -->
            <div v-if="!opened" class="packet-body">
                <div class="packet-top"></div>

                <div
                        class="open-btn"
                        :class="{ spinning: opening }"
                        @click="openRedPacket"
                >
                    {{$t('Open')}}
                </div>

                <div class="packet-text">
                    {{ displayTitle }}
                </div>
            </div>

            <!-- 已拆 -->
            <div v-else class="packet-result">
                <div class="amount">
                    {{$t('currency')}} {{ amount }}
                </div>
                <div class="tip">{{$t('Balance already deposited')}}</div>

                <van-button
                        type="primary"
                        color="#76b900"
                        block
                        @click="close"
                >
                    {{$t('Understood.')}}
                </van-button>
            </div>

        </div>
    </van-popup>
</template>

<script>
    export default {
        name: 'RedPacketPopup',
        props: {
            value: Boolean,
            title: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                show: this.value,
                opened: false,
                opening: false,
                amount: '0.00'
            }
        },
        watch: {
            value(val) {
                this.show = val
                if (val) {
                    this.opened = false
                    this.opening = false
                    this.amount = '0.00'
                }
            },
            show(val) {
                this.$emit('input', val)
            }
        },
        computed: {
            displayTitle() {
                return this.title || this.$t('Best wishes and good fortune')
            }
        },
        methods: {
            openRedPacket() {
                if (this.opening) return

                this.opening = true

                // 模拟动画时间
                setTimeout(() => {
                    this.requestGrab()
                }, 1200)
            },

            requestGrab() {
                this.$emit(
                    'open',
                    // 成功
                    (amount) => {
                        this.amount = amount
                        this.opened = true
                        this.opening = false
                    },
                    // ⭐ 失败
                    () => {
                        this.opening = false
                        this.show = false
                    }
                )
            },

            close() {
                this.opened = false
                this.amount = '0.00'
                this.show = false
            }
        }
    }
</script>

<style scoped>
    .red-popup {
        background: transparent;
    }

    .red-packet {
        width: 280px;
        background: #d3312d;
        border-radius: 12px;
        padding-bottom: 20px;
        text-align: center;
        color: #ffd7a2;
    }

    .packet-top {
        width: 100%;
        height: 140px;
        background: #e6453c;
        border-radius: 12px 12px 50% 50%;
    }

    .open-btn {
        width: 80px;
        height: 80px;
        background: #f7c97f;
        color: #b23a2f;
        border-radius: 50%;
        line-height: 80px;
        font-size: 26px;
        margin: -40px auto 20px;
        cursor: pointer;
        transition: transform 0.3s;
    }

    .open-btn.spinning {
        animation: spin 1s linear infinite;
    }

    .packet-text {
        font-size: 14px;
        margin-top: 10px;
    }

    .packet-result {
        padding: 40px 20px 0;
    }

    .amount {
        font-size: 36px;
        color: #ffd700;
        margin-bottom: 10px;
    }

    .tip {
        font-size: 14px;
        margin-bottom: 20px;
    }

    @keyframes spin {
        0% { transform: rotate(0); }
        100% { transform: rotate(360deg); }
    }
</style>
